import { render, staticRenderFns } from "./piechart.vue?vue&type=template&id=0f21ce5c&scoped=true"
import script from "./piechart.vue?vue&type=script&lang=js"
export * from "./piechart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f21ce5c",
  null
  
)

export default component.exports